export default __webpack_public_path__ + "static/component-8f2b6d92bd58b67ccacef023624b20f9.webp";